import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import _ from 'lodash'
import {
    Row,
    Col,
    Breadcrumb,
    Button,
    Table,
    DatePicker,
    Input,
    Modal,
    Divider,
    message,
} from 'antd'

import PositionForm from './Position'
import recruitmentService from './../services/recruitments.service'
import Toolbar from '../commons/Toolbar'

const {Search} = Input

class RecruitmentsView extends React.Component {
    state = {
        loading: true,
        recruitments: null,
        selectedRows: [],
        count: null,
        pageNum: 1,
        pageSize: 14,
        sortOrder: -1,
        sortBy: 'creationDate',
        filters: [],
        startDate: null,
        endDate: null,
        endOpen: false,
        searchString: null,
        positions: [],
        positionSelectedRowKeys: null,
        visible: false,
    }

    componentDidMount = async () => {
        this.getRecruitments()
    }

    getRecruitments = async () => {
        const {
            pageNum,
            pageSize,
            sortBy,
            sortOrder,
            filters,
            startDate,
            endDate,
            searchString,
        } = this.state

        const data = await recruitmentService.getRecruitments(
            pageNum,
            pageSize,
            sortBy,
            sortOrder,
            filters,
            startDate,
            endDate,
            searchString
        )

        const positions = await recruitmentService.getPositions()

        this.setState({
            recruitments: data.recruitments,
            count: data.totalCount,
            positions,
        })
    }

    showModal = () => {
        this.setState({
            visible: true,
        })
    }

    handleCancel = () => {
        this.setState({visible: false})
    }

    handleCreatePosition = async () => {
        const positions = await recruitmentService.getPositions()
        this.setState({positions})
    }

    handleDeletePosition = async () => {
        const res = await recruitmentService.deletePosition(
            this.state.positionSelectedRowKeys
        )
        if (res.rspCode === 'ok') message.success('Position deleted!')
        const positions = await recruitmentService.getPositions()
        this.setState({positions})
    }

    handleDownload = async () => {
        const arrayOfStringIds = _.map(this.state.selectedRows, '_id')
        recruitmentService.downloadRecruitmentFiles(arrayOfStringIds)
    }

    handleSearch = async () => {
        this.getRecruitments()
    }

    // DatePicker props
    getDatePickerProps = () => ({
        filterDropdown: () => (
            <div className="datepicker">
                <DatePicker
                    disabledDate={this.disabledStartDate}
                    format="MM-DD-YYYY"
                    value={this.state.startDate}
                    placeholder="Start"
                    onChange={this.onStartChange}
                    onOpenChange={this.handleStartOpenChange}
                />
                <DatePicker
                    disabledDate={this.disabledEndDate}
                    format="MM-DD-YYYY"
                    value={this.state.endDate}
                    placeholder="End"
                    onChange={this.onEndChange}
                    open={this.state.endOpen}
                    onOpenChange={this.handleEndOpenChange}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch()}
                    size="default"
                >
                    Search
                </Button>
                <Button
                    type="default"
                    onClick={() =>
                        this.setState(
                            {
                                startDate: null,
                                endDate: null,
                            },
                            () => this.getRecruitments()
                        )
                    }
                    size="default"
                >
                    Reset
                </Button>
            </div>
        ),
    })

    disabledStartDate = (startDate) => {
        const {endDate} = this.state
        if (!startDate || !endDate) {
            return false
        }
        return startDate.valueOf() > endDate.valueOf()
    }

    disabledEndDate = (endDate) => {
        const {startDate} = this.state
        if (!endDate || !startDate) {
            return false
        }
        return endDate.valueOf() <= startDate.valueOf()
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        })
    }

    onStartChange = (value) => {
        this.onChange('startDate', value)
    }

    onEndChange = (value) => {
        this.onChange('endDate', value)
    }

    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({endOpen: true})
        }
    }

    handleEndOpenChange = (open) => {
        this.setState({endOpen: open})
    }

    render() {
        const {
            isLoading,
            recruitments,
            selectedRows,
            positions,
            visible,
        } = this.state

        const columns = [
            {
                title: 'ID',
                dataIndex: 'extId',
                sorter: true,
            },
            {
                title: 'Name',
                dataIndex: 'name',
                sorter: true,
            },
            {
                title: 'Position',
                dataIndex: 'position',
                sorter: true,
            },
            {
                title: 'Nationality',
                dataIndex: 'nationality',
                sorter: true,
            },
            {
                title: 'Exp',
                dataIndex: 'yearsofexperience',
                sorter: true,
            },
            {
                title: 'Email',
                dataIndex: 'email',
                sorter: true,
            },
            {
                title: 'Phone',
                dataIndex: 'phone',
            },
            {
                title: 'Location',
                dataIndex: 'location',
                sorter: true,
            },
            {
                title: 'Created By',
                dataIndex: 'createdBy',
                filters: [
                    {
                        text: 'public',
                        value: 'public',
                    },
                    {
                        text: 'axiom admin',
                        value: 'axiom admin',
                    },
                ],
            },
            {
                title: 'Creation Date',
                dataIndex: 'creationDate',
                sorter: true,
                render: (text, record, index) => {
                    return record.creationDate.substring(0, 10)
                },
                ...this.getDatePickerProps(),
            },
            {
                title: 'Status',
                dataIndex: 'AxiomStatus',
            },
        ]

        const rowSelection = {
            type: 'checkbox',
            onSelect: (record, selected, selectedRows, nativeEvent) => {
                this.setState({
                    selectedRows: selectedRows,
                })
            },
        }

        const pagination = {
            total: this.state.count,
            pageSize: 14,
            pageSizeOptions: ['14'],
        }

        // Positions Modal
        const positionColumns = [
            {
                title: 'Name',
                dataIndex: 'name',
            },
        ]

        const positionRowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({positionSelectedRowKeys: selectedRowKeys})
            },
        }

        const toolBarItems = [
            {
                title: 'add',
                icon: 'user-add',
                onClick: () => {
                    this.props.history.push('/recruitments/add')
                },
            },
            {
                title: 'edit',
                icon: 'edit',
                onClick: () => {
                    if (selectedRows.length === 1) {
                        this.props.history.push({
                            pathname: '/recruitments/edit',
                            state: selectedRows,
                        })
                    }
                },
            },
            {
                title: 'export',
                icon: 'export',
                onClick: () => {
                    window.location.href = '/api/v1/recruitments/download/recruits.csv'
                },
            },
            {
                title: 'download',
                icon: 'download',
                onClick: this.handleDownload,
            },
            {
                title: 'positions',
                icon: 'team',
                onClick: this.showModal,
            },
        ]
        return (
            <div>
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        <Breadcrumb.Item>Recruitments</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider
                        style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}
                    />
                </Row>
                <Row>
                    <Col span={12}>
                        <Row type="flex" justify="start">
                            <Search
                                onSearch={(value) => {
                                    this.setState(
                                        {
                                            searchString: value,
                                        },
                                        () => this.getRecruitments()
                                    )
                                }}
                                style={{width: 330}}
                            />
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>

                        </Row>
                    </Col>
                    <Divider
                        style={{
                            background: 'transparent',
                            margin: '5px 0px 12px 0px',
                        }}
                    />
                </Row>
                <div style={{boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)'}}>
                    <section id="recruitments-default">
                        <Table
                            size="middle"
                            rowKey={'_id'}
                            columns={columns}
                            dataSource={recruitments}
                            pagination={pagination}
                            onChange={(pagination, filters, sorter) => {
                                this.setState(
                                    {
                                        pageNum: pagination.current,
                                        pageSize: pagination.pageSize,
                                        sortOrder: sorter.order === 'ascend' ? 1 : -1,
                                        sortBy: sorter.columnKey
                                            ? sorter.columnKey
                                            : 'creationDate',
                                        filters: [filters],
                                    },
                                    () => this.getRecruitments()
                                )
                            }}
                            rowSelection={rowSelection}
                            loading={isLoading}
                        />
                    </section>
                </div>
                <Modal
                    visible={visible}
                    title="Positions"
                    onCancel={this.handleCancel}
                    footer={[
                        <Button
                            key="delete"
                            type="danger"
                            loading={isLoading}
                            onClick={this.handleDeletePosition}
                        >
                            Delete
                        </Button>,
                    ]}
                >
                    <PositionForm
                        positions={positions}
                        handleCreatePosition={this.handleCreatePosition}
                    />
                    <Divider/>
                    <Table
                        rowKey={'_id'}
                        rowSelection={{
                            type: 'radio',
                            ...positionRowSelection,
                        }}
                        columns={positionColumns}
                        dataSource={positions}
                        scroll={{y: 400}}
                        pagination={false}
                    />
                </Modal>
            </div>
        )
    }
}

export default withRouter(RecruitmentsView)
